import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CurrentBrandScope } from '@principle-theorem/ng-principle-shared';
import { Patient, Recalls } from '@principle-theorem/principle-core';
import { type IPatient } from '@principle-theorem/principle-core/interfaces';
import { filterUndefined, firstValueFrom } from '@principle-theorem/shared';

@Component({
  selector: 'pr-add-patient',
  templateUrl: './add-patient.component.html',
  styleUrls: ['./add-patient.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddPatientComponent {
  private _brandScope = inject(CurrentBrandScope);

  constructor(
    private _dialogRef: MatDialogRef<AddPatientComponent, IPatient | undefined>
  ) {}

  async addPatient(patientData?: Partial<IPatient>): Promise<void> {
    const brand = await firstValueFrom(
      this._brandScope.doc$.pipe(filterUndefined())
    );
    if (!brand) {
      return;
    }
    const patient: IPatient = Patient.init({
      recall: Recalls.initPatientRecall(brand.settings.recalls),
      secondaryRecall: brand.settings.secondaryRecalls
        ? Recalls.initPatientRecall(brand.settings.secondaryRecalls)
        : undefined,
      ...patientData,
    });
    this._dialogRef.close(patient);
  }
}
